/** Shared easing / timing for landing-page entrance motion (matches existing FadeInUp). */
export const LANDING_MOTION_EASE = [0.22, 1, 0.36, 1] as const;

export const LANDING_MOTION_DURATION = 0.45;

export const LANDING_MOTION_Y = 14;
